/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ReceberBoletosEmailAliases {
  CARD_0 = 'card-0',
  CHECKBOX_0 = 'checkbox-0',
  FETCH = 'fetch',
  FIELD_0 = 'field-0',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_TERMO = 'field-termo',
  FIELDSET_EDITING = 'fieldset-editing',
  FIELDSET_VIEWING = 'fieldset-viewing',
  FORM = 'form',
  INPUT_0 = 'input-0',
  LAYOUT_RECEBER_BOLETOS_EMAIL = 'layout-receber-boletos-email',
  LINK_TERMOS = 'link-termos',
  PANEL_0 = 'panel-0',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
}
export { ReceberBoletosEmailAliases };
